import { useCallback, useEffect, useState } from 'react';
import { getDownloadUrl } from 'shared/utils/cloud/cloud';
import { Card } from '@mui/material';
import VideoPlayer from 'shared/components/VideoPlayer';
import { TDocFile } from 'shared/constants/docs';

type FilePlayerProps = Pick<TDocFile, '_id' | 'cloud'>;

export default function FilePlayer({ _id: id, cloud }: FilePlayerProps) {
	const [playURL, setPlayURL] = useState('');

	const preparePlayURL = useCallback(async () => {
		const urlResponse = await getDownloadUrl(cloud);
		if (urlResponse && urlResponse.url) {
			setPlayURL(urlResponse.url);
		}
	}, [cloud]);

	const init = useCallback(async () => {
		preparePlayURL();
	}, [preparePlayURL]);

	useEffect(() => {
		init();
	}, [init]);

	return (
		<Card sx={{ flex: 1, border: 'none' }}>
			<VideoPlayer id={id} src={playURL} />
		</Card>
	);
}
